import React from "react";

export default function SecondPage() {
  return <div>SecondPage</div>;
}
